function getNextBusinessDays(startDate, count) {
  const result = [];
  let date = new Date(startDate);

  // If today is Saturday (6) or Sunday (0), start from next Monday
  while (date.getDay() === 0 || date.getDay() === 6) {
    date.setDate(date.getDate() + 1);
  }

  while (result.length < count) {
    date.setDate(date.getDate() + 1);
    const day = date.getDay();
    if (day !== 0 && day !== 6) {
      result.push(new Date(date));
    }
  }
  return result;
}

function formatDate(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  return `${day}/${month}`;
}

function updateDeliveryEstimate() {
  const today = new Date();
  const businessDays = getNextBusinessDays(today, 3);
  const first = formatDate(businessDays[0]);
  const third = formatDate(businessDays[2]);

  const el = document.getElementById("delivery-estimate");
  if (el) {
    el.textContent = `${first} - ${third}`;
  }
}

// On initial page load
document.addEventListener("DOMContentLoaded", updateDeliveryEstimate);

// Listen for your cartUpdate pub/sub event
subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
  // Skip if event source is 'cart-items' since that might be handled elsewhere
  if (event.source === 'cart-items') return;

  updateDeliveryEstimate();
});
